define('models/StoreMessageModel',['models/MessageModel', 'app'],

    function (MessageModel, app)
    {
        //
        // MessageModel Store
        //

        var StoreMessageModelPrototype = {
            getPage:function(){
                return 'shop';
            }
        };

        var StoreMessageModel = MessageModel.extend(StoreMessageModelPrototype);

        return StoreMessageModel;
    });

